/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';
import { Form } from '@organisms';

const PositionField = ({ name, label, rules, initialValue, style, positions = [], ...props }) => (
  <Form.Item name={name} label={label} rules={rules} initialValue={initialValue} style={style}>
    <Select {...props}>
      {positions.map((position) => (
        <Select.Option key={position.key} value={position.key}>
          {position.label}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export default PositionField;
